import * as apiActions from '../actions/apiActions';
import * as apiValues from '../constants/apiValues';
import { MAP_IFRAME_TITLE, PROJECTS_MAP_CONTAINER_ARIA_LABEL } from '../constants/mapAccessibility';
import * as helpers from '../helpers';
import * as mapParentActions from '../actions/mapParentActions';
import * as projectActions from '../actions/projectActions';
import loadingIcon from '../img/loading-icon-small.gif';
import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from '../withRouterCompat';


const currentDomain = window.location.origin;

// let dcrMappingData = {
//   project_id: '',
//   pif: '',
//   params: [],
//   functionName: '',
//   selectedEditLayer: '',
//   currentProgram: 'all',
//   currentProgramStatus: 'all',
//   startDate: '2012',
//   endDate: '2018'
// };


class MapParent extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      collisions: 0,
      feedbackAddress: '',
      mapPluginReady: false,
    };
    this.isMapLoaded = false;

    this.componentDidMount = this.componentDidMount.bind(this);
    this.bindEvents = this.bindEvents.bind(this);
    this.sendMessageToChild = this.sendMessageToChild.bind(this);
    this.sendDirectlyToChild = this.sendDirectlyToChild.bind(this);
    this.recieveMessageFromChild = this.recieveMessageFromChild.bind(this);

    this.handleMessageFromChild = this.handleMessageFromChild.bind(this);

  }
  componentDidMount(){
    this.bindEvents();
  }
  componentDidUpdate(prevProps){
    const prev = prevProps.mProjectListMap;
    const next = this.props.mProjectListMap;

    if(prevProps.mapInactive && !this.props.mapInactive && this.isMapLoaded){
      this.syncMapProjects();
      return;
    }
    if(this.props.mapInactive){
      return;
    }
    if(!this.isMapLoaded){
      return;
    }

    const shouldSync =
      prev.projects !== next.projects ||
      prev.filter_program !== next.filter_program ||
      prev.filter_projectStatus !== next.filter_projectStatus ||
      prev.filter_projectType !== next.filter_projectType ||
      prev.filter_title !== next.filter_title ||
      (!prev.viewMap && next.viewMap);

    if(shouldSync){
      this.syncMapProjects();
    }
  }
  hasProjectListFilters = () => {
    const m = this.props.mProjectListMap;
    return !!(
      m.filter_program ||
      m.filter_projectStatus ||
      m.filter_projectType ||
      (m.filter_title && String(m.filter_title).trim())
    );
  };
  resolveArcgisProjectIds = (projectListIds) => {
    const {project} = this.props;
    if(!Array.isArray(projectListIds) || projectListIds.length === 0){
      return [];
    }
    return projectListIds
      .map(listId => project.find(p => p.id == listId))
      .filter(p => p && p.projectId)
      .map(p => p.projectId);
  };
  syncMapProjects = () => {
    const {mProjectListMap} = this.props;
    if(!this.isMapLoaded || this.props.mapInactive){
      return;
    }

    if(!this.hasProjectListFilters()){
      this.sendMessageToChild({
        functionName: 'setMapMode',
        params: ['projects'],
      });
      return;
    }

    const projectIds = this.resolveArcgisProjectIds(mProjectListMap.projects);
    if(projectIds.length === 0){
      this.sendMessageToChild({
        functionName: 'drawLayer',
        params: ['cms_project_polygons', false],
      });
      this.sendMessageToChild({
        functionName: 'drawLayer',
        params: ['project_centroids', false],
      });
      return;
    }

    this.sendMessageToChild({
      functionName: 'drawProjectsById',
      params: [projectIds],
    });
    this.sendMessageToChild({
      functionName: 'drawLayer',
      params: ['cms_project_polygons', true],
    });
  };


  /**
   * This function binds events from this javascript file to the browser
   */
  bindEvents(){
    // Assign handler to message event from the browser window.
    if(window.addEventListener){
      window.addEventListener('message', this.recieveMessageFromChild, false);
    }
    else if(window.attachEvent){ // supports ie8
      window.attachEvent('onmessage', this.recieveMessageFromChild);
    }
  }
  getNearbyProjects = data => {
    this.props.handleMapNearByProjects(data.projects);
  };
  navigateToProject = (slug) => {
    if(!slug){
      console.error('Project has no slug; cannot open project page.');
      return;
    }
    const targetUrl = `/projects/${slug}`;

    if(this.props.isPageProjectsExternal){
      window.parent.postMessage(JSON.stringify({
        source: 'page-projects-external',
        payload: window.location.origin + targetUrl,
      }), '*');
    }
    else{
      this.props.history.push(targetUrl);
    }
  };
  handleGoToProjectDetail = data => {
    const arcgisProjectId = data && data.project_id;
    if(arcgisProjectId === undefined || arcgisProjectId === null || arcgisProjectId === ''){
      return;
    }

    const selectedProject = this.props.project.find(item => item.projectId == arcgisProjectId);
    if(selectedProject && selectedProject.slug){
      this.navigateToProject(selectedProject.slug);
      return;
    }

    apiActions.loadEndpointByFilters(apiValues.nref.project.endpoint, {
      'filters[projectId][$eq]': String(arcgisProjectId),
    }).then(results => {
      const list = Array.isArray(results) ? results : (results ? [results] : []);
      const projects = apiActions.arraySelectCamelCaseKeys(list, apiValues.nref.project.fieldsUsed);
      const project = apiActions.pickBestProjectMatch
        ? apiActions.pickBestProjectMatch(projects)
        : projects[0];

      if(project && project.slug){
        this.props.projectActions.loadProjectSuccess(project);
        this.navigateToProject(project.slug);
        return;
      }
      console.error(`couldn't find project with id ${arcgisProjectId}`);
    }).catch(error => {
      console.error(`couldn't load project with id ${arcgisProjectId}`, error);
    });
  };
  handleMessageFromChild = (data) => {
    // DCR_Mapping test response
    // =============================

    //console.group("parent.html > parent.js > handleMessageFromChild");
    //console.log('data:', data);
    //console.log(typeof data);

    if(!data || typeof data.functionName !== 'string'){
      return;
    }

    switch(data.functionName){
        case 'mapPluginReady':
          this.mapLoaded();
          break;
        case 'projectPopupClicked':
          this.handleGoToProjectDetail(data);
          break;
        case 'updateFeatureCount':
          this.updateFeatureCount(data);

          break;

        case 'displayFeedbackAddressPoint':
          this.displayFeedbackAddressPoint(data);

          break;
        case 'getNearbyProjects':
          this.getNearbyProjects(data);
          break;
        case 'test':
          //console.log('testData from Child:', data);

          break;

      default:
      //console.warn("Error with payload data", data);
    }
  };
  handleNearByProjects = () => {
    this.sendMessageToChild({
      functionName: 'getNearbyProjects',
      params: [1],
    });
  };
  handleProjectRedirect = () => {
    //handleProjectRedirect = data => {
    // const { project_id } = data;
    // this.props.actions.initMapParent(project_id);
  };
  mapLoaded = () => {
    this.isMapLoaded = true;
    if(!this.props.mapInactive){
      this.syncMapProjects();
    }
    setTimeout(() => this.setState({
      mapPluginReady: true,
    }), 5000);
  };
  /**
   * This function listens for an event from the browser message event and returns a JSON
   * @param {*} event
   */
  recieveMessageFromChild(event){
    //console.group("MAPPARENT parent.html > parent.js > recieveMessageFromChild");
    //console.log(event);

    if(event.origin === currentDomain){ //WARNING this is used to verify the source of the message, aka whitelist
      // Retrieve data sent in postMessage

      //console.log("MAPPARENT event.origin", event.origin);
      //console.log("MAPPARENT currentDomain", currentDomain);
      //console.log("MAPPARENT event.data", event.data);

      if(event.data){
        let data;
        if(typeof event.data === 'string'){
          try {
            data = JSON.parse(event.data);
          }
          catch (e){
            return;
          }
        }
        else if(typeof event.data === 'object'){
          data = event.data;
        }
        else{
          return;
        }

        if(!data.functionName){
          return;
        }

        this.handleMessageFromChild(data);
        return data;
      }
      else{
        //console.warn("Check message payload on event.data", event.data);
      }
    }
    else{
      //console.warn("Error with validating origin: " + event.origin + " !== " + currentDomain);
    }
  }
  /**
   * // TODO: Talk to Roland about strictly defining the params as a JSON Object,
   * that way you can just use this function and pass parameters directly,
   * with a strictly defined JSON Object he would have easier time validating the parameters too
   *
   * Currently this will not work unless his parameters are properly defined.
   *
   * @param {*} event
   */
  sendDirectlyToChild(event){
    //console.group("parent.html > parent.js > sendDirectlyToChild");
    //console.log(event);


    this.sendMessageToChild({
      functionName: event.target.getAttribute('service-task'),
      params: [],
    });
    //console.groupEnd();
  }
  /**
   * This function sents a message from the parent to the child.
   *
   * It can be called by passing a JSON as an example
   *
   * sentMessageToChild({ //payload is being defined at the moment w/ DCR Maps Team.
        mapMode: programs-projects, // can also be program-projects, project-details, feedback, memorial
        program: [vision_zero, active_transporation, ...]
        projects: [data_collection_feedback, plannding_design, construction, ...] , // can also be data_collection_feedback, planning_design, construction, completed, post_project_evaluation, active
        ui_ZoomLevel: "lab-zoom", // defines HTML element showing current zoomlevel,
   * })
   *
   */
  sendMessageToChild(payload){
    //console.group("parent.html > parent.js > sendMessageToChild");
    //console.log(payload);
    if(payload && this.iframe){
      this.iframe.contentWindow.postMessage(JSON.stringify(payload), currentDomain);
    }

    //console.log("MAPPARENT -> dcrMappingData: ", dcrMappingData);
    //console.groupEnd();
  }


  renderMapLoadingIconDesktop = () => {
    if(this.state.mapPluginReady) return null;

    return (<img alt="Loading" src={loadingIcon} className="map-loading-icon"/>);
  };
  renderMapLoadingIconMobile = () => {
    if(this.state.mapPluginReady) return null;

    return (<img alt="Loading" src={loadingIcon} className="map-loading-icon-mobile"/>);
  };
  render(){
    return (
      <div className={`m-projectlistmap ${this.props.className || ''}`}>
        <div className="m-projectlistmap__map-iframe-container"
             aria-label={PROJECTS_MAP_CONTAINER_ARIA_LABEL}>
          {this.renderMapLoadingIconDesktop()}
          {this.renderMapLoadingIconMobile()}
          <iframe className="m-projectlistmap__map-iframe"
                  title={MAP_IFRAME_TITLE}
                  tabIndex={this.props.mapInactive ? -1 : undefined}
                  src={`/maps/child.html?cms_path=${apiValues.getCmsPath()}`}
                  ref={(event) => (this.iframe = event)}/>
        </div>
      </div>
    );
  }
}


export default withRouter(connect(
  (state, ownProps) => ({
    MapParent: helpers.getById(state.mapParent, ownProps.cmsId),
    mProjectListMap: state.mProjectListMap,
    project: state.project,
  }),
  (dispatch) => ({
    actions: bindActionCreators(mapParentActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch),
  }),
)(MapParent));


MapParent.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string,
  cmsId: PropTypes.string,
  handleMapNearByProjects: PropTypes.func,
  history: PropTypes.object,
  isPageProjectsExternal:PropTypes.bool,
  mapInactive: PropTypes.bool,
  MapParent: PropTypes.object,
  mProjectListMap: PropTypes.object,
  project: PropTypes.array,
  projectActions: PropTypes.object.isRequired,
};
